import { Browser } from '@smoovy/utils';

export const iOSAgent = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const iOSPlatform = window.navigator.platform && window.navigator.platform.match(/iPhone|iPod|iPad/);
const iOSRequestDesktop = (!iOSAgent && iOSPlatform);

export const isTouch = () => 'ontouchstart' in window || navigator.maxTouchPoints;

export const isMobile = () => iOSRequestDesktop
  || Browser.mobile
  || iOSAgent
  || Browser.android;

export const isDesktop = () => !Browser.mobile
  && !iOSAgent
  && !Browser.android
  && !iOSRequestDesktop;

export const isSafari = () => Browser.safari;

export const isIOS = () => Browser.ios;
